import {
    $,
    $$,
    get,
    show,
    hide,
    getData,
    gtmSimpleEvent,
    Key,
    clickOnEnterKey,
    findClosestMatchingChildWithClass, isVisible
} from '@/Utils';
import {initSearch} from '@/SearchNode';
import {initDropdowns} from '@/sharedComponents/Dropdown/Dropdown';
import {initCustomerService} from '@/sharedComponents/Header/CustomerService';
import {bindCartPanelDeletes, closePanel, fetchAndInsertPartial, openPanel} from '@/sharedComponents/Panel';
import {initSliders} from '@/CustomSlider.js';
import {GtmEventType} from "@/enums";
import {EventDetail} from "@/interfaces";

async function initNavListeners() {
    const mainNavElement = $(".main-nav");
    if (!mainNavElement.getAttribute("data-menu-loading-started")) {
        mainNavElement.setAttribute("data-menu-loading-started", "true");
        const menuInitHandler = async () => {
            await fetchAndInsertPartial(window.config.getCategoryMenuUrl, "category-menu", "#categoryMenu");
            window.dispatchEvent(new Event('menuInitialized'));
            mainNavElement.removeEventListener("mouseover", menuInitHandler);
        };
        // On mobile there's no mouseover.
        if (isResponsive){
            if (window.config.controller == "Home"){
                await menuInitHandler()
            }
        } else {
            mainNavElement.addEventListener("mouseover", menuInitHandler, {once: true})
        }
        $$(".sub-menu__container").forEach(container => {
            const childCount = container.childElementCount;
            Array.from(container.children).forEach(e => e.classList.toggle("grow", childCount < 5));
        });
    }
}
async function initHeader() {
    $$(".main-nav__item").forEach(elem => {
        elem.addEventListener("click", async (event) => {
            try {
                await toggleHeaderMenu.call(elem, event);
            } catch (error) {
                console.error('Error in header menu toggle:', error);
            }
        });
        if (!elem.hasAttribute("data-keydown-bound")) {
            elem.addDataBoundEventListener("keydown", (event: KeyboardEvent) => {
                if (document.activeElement === elem) {
                    clickOnEnterKey(event, elem);
                }
            }, "enter-keypress-bound");
            elem.setAttribute("data-keydown-bound", "true");
        }
    });

    document.addEventListener("click", closeOverlay);

    document.addEventListener("keyup", escToClose);
    document.addEventListener("keydown", arrowNavigation);
    bindCartPanelDeletes();
    initSliders();

    $$(".sub-menu__mid-level-container").forEach(x => {
        x.addDataBoundEventListener("click", (e: Event) => {
            const activeClass = "sub-menu__block--active";
            const container = (e.currentTarget as HTMLElement).closest(".sub-menu__block");
            const deactivate = container.classList.contains(activeClass);
            $(`.${activeClass}`)?.classList.remove(activeClass);
            if (!deactivate)
                container.classList.add(activeClass);
            if (window.isResponsive)
                container.scrollIntoView({behavior: "smooth"});
        })
    })
    $$(".sub-menu__block-heading").forEach(x => {
        x.addDataBoundEventListener("keydown", (event: KeyboardEvent) => {
            clickOnEnterKey(event, x);
        }, "enter-keypress-bound")
    })
    $$(".responsive-panel__back").forEach(x => {
        x.addDataBoundEventListener("click", closeOverlay);
    })

    $(".search").addEventListener("click", toggleResponsiveSearch);

    if (get("Home")) {
        $(".autocomplete__wrapper")?.classList.add("visible");
    }

    focusSkipLinkOnFirstTab();
}

function handleMetagroups(e: KeyboardEvent, activeEl: HTMLElement){
    if (e.key === Key.ArrowLeft) {
        e.preventDefault();
        (activeEl.previousElementSibling as HTMLElement)?.focus()
    } else if (e.key === Key.ArrowRight) {
        e.preventDefault();
        (activeEl.nextElementSibling as HTMLElement)?.focus()
    } else if (e.key === Key.ArrowDown) {
        e.preventDefault()
        if (!activeEl.classList.contains("main-nav__item--active")) {
            activeEl.click();
        }
        const firstEl = activeEl.querySelector(".sub-menu__block a, .sub-menu__block [tabindex]") as HTMLElement
        firstEl.focus()
    }
}

function handleServicesGroups(e: KeyboardEvent, activeEl: HTMLElement){
    if (e.key === Key.ArrowLeft) {
        e.preventDefault();
        (activeEl.previousElementSibling.querySelector(".nav-item__link") as HTMLElement)?.focus()
    } else if (e.key === Key.ArrowRight) {
        e.preventDefault();
        (activeEl.nextElementSibling.querySelector(".nav-item__link") as HTMLElement)?.focus()
    }
}

function handleSubGroups(e: KeyboardEvent, activeEl: HTMLElement, subMenuBlock: Element){
    const subMenuContainer = subMenuBlock.closest(".sub-menu__container")
    if (e.key === Key.ArrowLeft || e.key === Key.ArrowRight) {
        const nextEl: HTMLElement = e.key === Key.ArrowLeft ?
            subMenuBlock.previousElementSibling?.querySelector("a, [tabindex]") :
            subMenuBlock.nextElementSibling?.querySelector("a, [tabindex]")
        if (nextEl) {
            nextEl.focus()
        }
    } else {
        const navigatable = Array.from(subMenuContainer.querySelectorAll("a, [tabindex]")).filter(x => isVisible(x as HTMLElement))
        if (e.key === Key.ArrowDown) {
            e.preventDefault()
            const selectedIdx = navigatable.indexOf(activeEl)
            const toSelectIdx = selectedIdx >= navigatable.length - 1 ? selectedIdx : selectedIdx + 1;
            (navigatable[toSelectIdx] as HTMLElement).focus()
        } else if (e.key === Key.ArrowUp) {
            e.preventDefault()
            const selectedIdx = navigatable.indexOf(activeEl)
            if (selectedIdx < 1) {
                const htmlElement = subMenuContainer.closest(".main-nav__item") as HTMLElement;
                htmlElement.click()
                htmlElement.focus()
            } else {
                (navigatable[selectedIdx - 1] as HTMLElement).focus()
            }
        }
    }
}
function handleProductCards(e: KeyboardEvent, activeEl: HTMLElement){   
    let newSelection : HTMLElement
    if (e.key === Key.ArrowLeft) {
        e.preventDefault()
        newSelection = activeEl.previousElementSibling as HTMLElement
    } else if (e.key === Key.ArrowRight) {
        e.preventDefault()
        newSelection = activeEl.nextElementSibling as HTMLElement
    }
    (newSelection?.querySelector(".product_name") as HTMLElement)?.focus()
}
function arrowNavigation(e: KeyboardEvent) {
    const activeEl = document.activeElement as HTMLElement
    if (activeEl.classList.contains("main-nav__item")) {
        handleMetagroups(e, activeEl)
    }
    if(activeEl.classList.contains("nav-item__link")){
        handleServicesGroups(e, activeEl.parentElement.parentElement)
    }
    const subMenuBlock = activeEl.closest(".sub-menu__block")
    if(subMenuBlock){
        handleSubGroups(e, activeEl, subMenuBlock)
    }
    const productCard = activeEl.closest(".product-card") as HTMLElement
    if(productCard){
        handleProductCards(e, productCard)
    }
}

function focusSkipLinkOnFirstTab() {
    let isFirstTabPress = true;

    document.addEventListener('keydown', (event) => {
        if (event.key === Key.Tab && isFirstTabPress) {
            const activeElement = document.activeElement;
            const skipToMain = get('skip-to-main');
            const searchKeyword = get('searchKeyword');

            //If during the first tab press focus is on search(site default) or there is no focused element yet, focus on skip to main.
            if ((!searchKeyword || activeElement === searchKeyword) && skipToMain) {
                event.preventDefault();
                skipToMain.focus();
            }
            isFirstTabPress = false;
        }
    });
}


function toggleResponsiveSearch() {
    if (window.isResponsive) {
        $(".autocomplete__wrapper")?.classList.toggle("visible");
        const searchInput = get('searchKeyword') as HTMLInputElement;
        searchInput?.focus();
    }
}

function closeOverlay(event: Event) {
    if ($$("#categoryMenu .main-nav__item--active").length) {
        if (!(event.target instanceof Element) || (!window.isResponsive && (event.target as Element).closest(".main-nav"))) return;
        $$(".main-nav__list .main-nav__item--active").forEach(elem => {
            elem.classList.remove("main-nav__item--active")
        });
        hide($(".sub-nav__footer") as HTMLElement);
        $$(".header__overlay.header__overlay--active").forEach(elem => {
            elem.classList.remove("header__overlay--active")
        });
    }
}

async function toggleHeaderMenu(this: HTMLElement, event: Event) {
    event.stopPropagation();
    const targetElement = event.target as HTMLElement;
    if (targetElement == null) return;
    let closestDiv = targetElement.closest(".nav-item__label");
    closestDiv ??= findClosestMatchingChildWithClass(targetElement, "nav-item__label");
    if (closestDiv == null) return;
    const footer = $(".sub-nav__footer") as HTMLElement;
    const overlay = $(".header__overlay") as HTMLElement;
    $$(".main-nav__item").forEach(elem => {
        if (this === elem) {
            if (elem.classList.contains("main-nav__item--active")) {
                elem.classList.remove("main-nav__item--active");
                overlay.classList.remove("header__overlay--active");
                hide(footer);
            } else {
                elem.classList.add("main-nav__item--active");
                if (!window.isResponsive) {
                    overlay.classList.add("header__overlay--active");

                }
                show(footer);
                const activeSubmenu = $(".main-nav__item--active .sub-menu") as HTMLElement;
                if (activeSubmenu != null) {
                    footer.style.top = activeSubmenu.clientHeight + "px";
                }
            }
        } else {
            elem.classList.remove("main-nav__item--active");
        }
    });
    return false
}

function escToClose(event: KeyboardEvent) {
    const panelWrapperActive = $(".panel__wrapper--active");
    if (panelWrapperActive) {
        const panel = $(".panel");
        trapFocus(panel as HTMLElement);

        if (event.key === Key.Escape) {
            closePanel();
        }
    }
    const mainNavActive = $(".main-nav__item--active");
    if (mainNavActive && event.key === Key.Escape) {
        mainNavActive.classList.remove("main-nav__item--active");
        $(".header__overlay").classList.remove("header__overlay--active");
        hide($(".sub-nav__footer"));
    }
}

function isOnScreen(element: Element) {
    const curTop = element.scrollTop;
    const screenHeight = (window as any).height;
    return !(curTop > screenHeight || curTop === 0);
}

function trapFocus(element: HTMLElement) {
    let firstFocusableEl: HTMLElement;
    let lastFocusableEl: HTMLElement;
    element.querySelectorAll(
        "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type=\"text\"]:not([disabled]), input[type=\"radio\"]:not([disabled]), input[type=\"checkbox\"]:not([disabled]), select:not([disabled]), h2[tabindex=\"-1\"]")
        .forEach(elem => {
            if (!isOnScreen(elem)) return;
            firstFocusableEl = firstFocusableEl === null ? elem as HTMLElement : firstFocusableEl;
            lastFocusableEl = elem as HTMLElement;
        });

    element.addEventListener("keydown", e => {
        if (e.key !== Key.Tab) {
            return;
        }

        if (e.shiftKey) /* shift + tab */ {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else /* tab */ {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }

    });
}

function initHeaderTabs(initialLoad: boolean) {
    let tab: HTMLElement = null
    if (initialLoad) {
        const selectedMenuId = history.state?.selectedMenuId
        if (selectedMenuId)
            tab = $(`[data-menu-id="${selectedMenuId}"]`)

    }
    if (!tab) {
        const hash = window.location.hash
        if (hash) {
            const elem = $(`[data-hash="${hash}"]`)
            if (elem) {
                closePanel();
                tab = elem
            }
        }
    }
    tab ??= $("[data-header-tab].tabs__item--active")
    activateHeaderTab(tab);

    $$("[data-header-tab]").forEach(x => x.addEventListener("click", () => {
        if (x.hasAttribute("data-tab-url")) {
            location.href = x.getAttribute("data-tab-url");
            return;
        }
        activateHeaderTab(x)
    }))

    $$("[data-header-tab]").forEach(x => x.addEventListener("keydown", (event: KeyboardEvent) => {
        if (event.key === Key.Enter) {
            if (x.hasAttribute("data-tab-url")) {
                location.href = x.getAttribute("data-tab-url");
                return;
            }
            activateHeaderTab(x, true)
        }
    }))

    function activateHeaderTab(target: HTMLElement, shiftFocus: boolean = false) {
        if (!target) {
            // Problem - User ends up in a tab that is not visible like /en/news
            // We cannot activate news tab as its not there.
            // Solution: We just take first tab.
            activateHeaderTab(tab ??= $("[data-header-tab]"))
            return;
        }
        if (!target.classList.contains("tabs__item--active")) {
            const prevTab = $(".tabs__item--active")
            if (prevTab) {
                prevTab.classList.remove("tabs__item--active")
                if (prevTab.hasAttribute("data-menu-id"))
                    hide(get(prevTab.getAttribute("data-menu-id")))
            }
            target.classList.add("tabs__item--active")
        }
        const menuId = target.getAttribute("data-menu-id")
        if (menuId) {
            show(get(menuId))
            history.replaceState({selectedMenuId: menuId}, '')
            if (shiftFocus) {
                if (menuId === "servicesMenu") {
                    $(`#${menuId} .main-nav__item .nav-item__link`).focus()
                } else {
                    $(`#${menuId} .main-nav__item`).focus()
                }
            }
        }
    }
}

function initHashLinks() {
    $$("[data-hash-link]").forEach(x => x.addEventListener("click", () => {
        window.location.href = x.getAttribute("data-hash-link")
        initHeaderTabs(false)
    }))
}

function initFreeLimit() {
    const freeLimit = get("free-limit");
    if (!freeLimit) {
        return;
    }
    getData(window.config.lhvFreeLimit, x => {
        x.text().then(text => freeLimit.textContent = text);
    }, false);
}

function initLangDropdown() {
    const dd = get("language-selector");
    if (dd) {
        initDropdowns();
        dd.addEventListener("valueChange", (e: CustomEvent<EventDetail>) => {
            const callback = () => {
                window.location.href = e.detail.value
            }
            gtmSimpleEvent(GtmEventType.LanguageChange, e.detail.value, callback);
        });
    }
}

function removePreload() {
    $$(".preload").forEach(x => x.classList.remove("preload"));
}

function initHighlightListener() {
    const elem = get("customer-service-button");
    elem?.addEventListener("click", () => {
        elem.classList.add("highlighted");
    });
}

async function conditionalOpenPanel() {
    const urlParams = new URLSearchParams(window.location.search);
    const loginParams = ["login", "prisijungti"];
    const registerParams = ["register", "registreeri", "registruotis", "registreties", "registratsiya"];
    const contactParams = ["kontakt", "contact", "kontakts", "susisieksumumis"];

    const isLoginPanel = loginParams.some(param => urlParams.has(param));
    const isRegisterPanel = registerParams.some(param => urlParams.has(param));
    const isContactParam = contactParams.some(param => urlParams.has(param));

    if(isContactParam) {
        openPanel("customer-service-panel");
    } else if (!window.currentUser.IsLoggedIn && (isLoginPanel || isRegisterPanel)) {
        if(isRegisterPanel){
            const registerTab = $('[data-tab-id="register-tab"]') as HTMLElement;
            registerTab.classList.add("tabs-menu__item--active");
            const loginTab = $('[data-tab-id="login-tab"]') as HTMLElement;
            loginTab.classList.remove("tabs-menu__item--active");

        }
        await fetchAndInsertPartial(window.config.getSidePanelUrl, "login-panel");
        openPanel("login-panel");
    }
}

const initResponsiveBannerSliders = () => {
    if (window.isResponsive) {
        initSliders()
    }
}

window.addEventListener("load", () => {
    initSearch()
    initCustomerService()
    initFreeLimit()
    initLangDropdown()
    removePreload()
    initHashLinks()
    window.responsiveObserverFunctions = (window.responsiveObserverFunctions || [])
    window.responsiveObserverFunctions.push(initResponsiveBannerSliders)
})

window.addEventListener("load", () => {
    initHeader()
    initNavListeners()
    initHeaderTabs(true)
    conditionalOpenPanel()
    initHighlightListener()
})
window.addEventListener("menuInitialized", () => {
    initHeader()
})
